import { styled } from 'baseui'
import { lightTheme } from '@/customTheme'

/**
 * Shared panel shell for all side-panel thumbnail lists (Scenes, AI result grids, etc.).
 * Provides the common visual shell: border, backdrop, padding, scroll and flex spacers.
 * Callers add their own positioning, sizing, and animation on top. `$horizontal`
 * turns it into a row under a top border that scrolls sideways without a bar.
 */
export const ScenesPanelShell = styled('div', ({ $horizontal = false }: { $horizontal?: boolean }) => ({
  boxSizing: 'border-box',
  display: 'flex',
  ...($horizontal ? {
    flexDirection: 'row',
    overflowX: 'auto',
    overflowY: 'hidden',
    overscrollBehaviorX: 'contain',
    // 12px from the top of the border line, which sits inside the row's height.
    padding: '11px 16px 12px',
    borderTop: `1px solid ${lightTheme.colors.grayScale150}`,
    scrollbarWidth: 'none',
    '::-webkit-scrollbar': { display: 'none' },
  } : {
    flexDirection: 'column',
    overflowY: 'auto',
    overflowX: 'hidden',
    padding: '12px 8px 12px 12px',
    borderLeft: `1px solid ${lightTheme.colors.grayScale150}`,
    borderRight: '4px solid transparent',
    '::-webkit-scrollbar': {
      width: '6px',
    },
    '::-webkit-scrollbar-track': {
      borderRadius: '4px',
    },
    '::-webkit-scrollbar-thumb': {
      borderRadius: '4px',
      backgroundColor: lightTheme.colors.grayScale200,
      minHeight: '100px',
    },
    '::-webkit-scrollbar-thumb:hover': {
      cursor: 'pointer',
      backgroundColor: lightTheme.colors.grayScale300,
    },
  }),
  backdropFilter: 'blur(10px)',
  backgroundColor: 'rgba(242, 242, 242, 0.95)',
  '::before': {
    content: '""',
    flex: '1',
  },
  '::after': {
    content: '""',
    flex: '1',
  },
}))
